import React from "react";
import "./CustomButton.scss";
import { TfiReload } from "react-icons/tfi";

const CustomButton = ({
  type,
  handleSubmit,
  name,
  color,
  disabled,
  bigButton,
  loader,
  id,
}) => {
  if (id) {
    return (
      <button
        id={id}
        disabled={disabled}
        className={`custom-button ${color} ${bigButton ? "big" : ""}`}
        onClick={() => {
          if (!disabled) {
            handleSubmit();
          }
        }}
        type={type}
      >
        {loader ? <TfiReload className="loading-button" /> : name}
      </button>
    );
  } else {
    return (
      <button
        disabled={disabled}
        className={`custom-button ${color} ${bigButton ? "big" : ""}`}
        onClick={() => {
          if (!disabled) {
            handleSubmit();
          }
        }}
        type={type}
      >
        {loader ? <TfiReload className="loading-button" /> : name}
      </button>
    );
  }
};

export default CustomButton;
